import { mergeQueryString, QueryCombiner, updateSearch } from 'bernie-core';

export const openInSameTab = url => window.location.assign(url);

export const openInNewTab = url => window.open(url, '_blank', 'noopener,noreferrer');

export const openOffer = (url, isSmallViewport) => (isSmallViewport ? openInSameTab(url) : openInNewTab(url));

export const updateUrl = (history, location, pwaDialog?, upsellOfferToken?: string) => {
  const queryCombiner: QueryCombiner = (prevQuery, newQuery) => newQuery;
  updateSearch({
    history,
    location,
    newParams: mergeQueryString(location.search, {
      pwaDialog: pwaDialog,
      upsellOfferToken: upsellOfferToken ?? undefined
    }),
    replace: true,
    queryCombiner
  });
};
